import { RadioButton } from "ui";
import { SupportedTeleProviders } from "@elixir/types";
import useTeleConfigurationStore from "../../../../../stores/vc-meta-store";

function EkaTelePlatform() {
  const vcPlatform = useTeleConfigurationStore((state) => state.platform);
  const setVcPlatform = useTeleConfigurationStore((state) => state.setPlatform);
  return (
    <RadioButton
      isSelected={vcPlatform === SupportedTeleProviders.eka}
      label="Eka's Video Platform"
      onClick={() => {
        setVcPlatform(SupportedTeleProviders.eka);
      }}
    />
  );
}

export default EkaTelePlatform;
